import { Heading } from '@ctw/shared/components/heading';
import { LegacyTable } from '@ctw/shared/components/tables/legacy-table';
import { DocumentViewerDetailFields } from '@ctw/shared/content/document-viewer/_internal/viewer/document-viewer-detail-fields';
import { DOCUMENT_VIEWER_DETAIL_SUBSECTION_TEST_ID } from '@ctw/shared/test/ids';
import { isCdaDetailSubsectionTable } from '@ctw/shared/utils/cda/helpers';
import type { CdaDetailSubsection } from '@ctw/shared/utils/cda/types';
import { uniqueIdentifierHash } from '@ctw/shared/utils/hash';
import { tw } from '@ctw/shared/utils/tailwind';
import type { ReactNode } from 'react';

export interface DocumentViewerDetailSubsectionProps {
  subsection: CdaDetailSubsection;
}

export const DocumentViewerDetailSubsection = ({
  subsection,
}: DocumentViewerDetailSubsectionProps) => {
  return (
    <section
      data-testid={DOCUMENT_VIEWER_DETAIL_SUBSECTION_TEST_ID}
      className={tw`flex flex-col gap-2`}
    >
      <Heading level="h3">{subsection.title}</Heading>
      {isCdaDetailSubsectionTable(subsection) ? (
        <LegacyTable
          className={tw`rounded-md border`}
          title="Summary Settings"
          columns={subsection.columns.map((title, columnIndex) => ({
            title: title as ReactNode,
            render: (row) => (row as unknown as Record<string, Array<string>>).values[columnIndex],
          }))}
          records={subsection.rows.map((row) => ({
            key: uniqueIdentifierHash(row.join('')),
            values: row,
          }))}
        />
      ) : (
        <DocumentViewerDetailFields fields={subsection.fields} />
      )}
    </section>
  );
};
